import type {DefaultTheme} from "styled-components"

const getRankingColor = (ranking: number, theme: DefaultTheme) => {
  if (ranking === 1) {
    return theme.colors.utility.gold
  }
  if (ranking === 2) {
    return theme.colors.utility.silver
  }
  if (ranking === 3) {
    return theme.colors.utility.bronze
  }
  return theme.colors.utility.ink
}

export default getRankingColor
